/**
 * @description  Dydu API values
 * see :
 * - https://app1.earth.doyoudreamup.com/servlet/api/doc/index.html#/Chat/postFeebackRequest
 * - https://app1.earth.doyoudreamup.com/servlet/api/doc/index.html#/Chat/postFeedbackSatisfactionRequest
 * - https://app1.earth.doyoudreamup.com/servlet/api/doc/index.html#/Chat/postFeedbackCommentRequest
 */

export default Object.freeze({
  STEP_ONE: {
    POSITIVE: 'positive',
    NEGATIVE: 'negative',
  },
  STEP_TWO: {
    NOT_CLEAR: 0,
    NOT_SATISFIED: 1,
    NOT_UNDERSTOOD: 2,
  },
})
